import { UserManager, UserManagerSettings } from 'oidc-client-ts';
import oidcConfig from '../oidcConfig';

// Én felles instans for AuthProvider og vår egen fornyelse. Vi trenger den
// direkte fordi react-oidc-context sin signinSilent svelger feil (returnerer
// null) og setter isLoading=true mens den kjører — se medDirekteFornyelse().
const userManager = new UserManager(oidcConfig as UserManagerSettings);

export default userManager;
